import { memo } from "react";
import { NotificationBadge } from "@/shared/components/NotificationBadge";
import { useAdminNotificationsContext } from "@/shared/contexts/AdminNotificationsProvider";

export const LegalQuestionUnreadCounter = memo(() => {
  const { counts } = useAdminNotificationsContext();
  return <NotificationBadge count={counts.legal_questions_unread} />;
});

LegalQuestionUnreadCounter.displayName = "LegalQuestionUnreadCounter";
